import { axiosInstance } from "./axiosInstance";

// 1. 회원 목록 조회
export const getAdminMembers = async (params: { searchKeyword?: string; status?: string; page?: number; size?: number }) => {
    try {
        const response = await axiosInstance.get(`/api/admin/members`, { params });
        return response.data;
    } catch (error) {
        console.error("회원 목록 조회 에러:", error);
        throw error;
    }
};

// 2. 회원 상세 조회 (기본 정보 + 배송지)
export const getAdminMemberDetail = async (memberId: string | number) => {
    try {
        const response = await axiosInstance.get(`/api/admin/members/${memberId}`);
        return response.data;
    } catch (error) {
        console.error("회원 상세 조회 에러:", error);
        throw error;
    }
};

// 3. 회원 정보 수정
export const updateAdminMember = async (memberId: string | number, data: any) => {
    try {
        const response = await axiosInstance.put(`/api/admin/members/${memberId}`, data);
        return response.data;
    } catch (error) {
        console.error("회원 수정 에러:", error);
        throw error;
    }
};

// 4. 회원 삭제(탈퇴)
export const deleteAdminMember = async (memberId: string | number) => {
    try {
        const response = await axiosInstance.delete(`/api/admin/members/${memberId}`);
        return response.data;
    } catch (error) {
        console.error("회원 삭제 에러:", error);
        throw error;
    }
};

// 신규 회원 생성
export const createAdminMember = async (data: any) => {
    try {
        const response = await axiosInstance.post(`/api/admin/members`, data);
        return response.data;
    } catch (error) {
        console.error("회원 생성 에러:", error);
        throw error;
    }
};